import theme from "@/theme";

const EditIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.85159 14.3157L14.3171 4.85016C14.6746 4.49266 15.2548 4.49266 15.6123 4.85016L17.1487 6.38649C17.5062 6.74399 17.5062 7.32424 17.1487 7.68174L7.68226 17.1463C7.51084 17.3187 7.27801 17.4149 7.03509 17.4149H4.58301V14.9628C4.58301 14.7199 4.67926 14.4871 4.85159 14.3157Z"
      stroke={theme.palette.custom.mainBlue}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6045 6.5625L15.437 9.395"
      stroke={theme.palette.custom.mainBlue}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default EditIcon;
